import React from 'react';
import PropTypes from 'prop-types';

const InformationIcon = ({ color = "#64748B", size }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8333 13.3333H10V10H9.16667M10 6.66667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

InformationIcon.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
};

InformationIcon.defaultProps = {
    color: 'currentColor',
    size: '30px',
};

export default InformationIcon;
